export const EditSvg = () => <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.9307 13V14H0.132812V13H12.9307ZM7.59735 1.997L10.7973 4.997L3.41708 12H0.132812V8.999L7.59841 1.997H7.59735ZM9.73921 0L12.9328 3.001L11.8608 4.005L8.66615 1.003L9.73815 0H9.73921Z" fill="#1F1F1F" />
</svg>
